/* Revotion · Lottie-Füllstand-Renderer (wiederverwendbar).
   Findet alle .rv-lottie / .lvl-lottie[data-lottie][data-frame] und rendert die
   echte Lottie (window.RV_LOTTIE oder window.LEVEL_LOTTIE) — für Batterien, Tanks,
   Gauge, Compass. data-frame = 0..100 (Prozent/Wert).
   Standard: animiert von 0 → Zielwert beim Erst-Render (Füll-Effekt). Spätere
   Wert-Änderungen via RVLottie.set(el, pct, true) tweenen sanft zum neuen Stand.
   data-animate="off" → ohne Animation einfrieren. data-fit überschreibt preserveAspectRatio.
   Voraussetzung: lottie-web + die Daten-Datei(en) sind geladen. */
(function () {
  function clone(o) { return JSON.parse(JSON.stringify(o)); }
  function dataFor(name) {
    return (window.RV_LOTTIE && window.RV_LOTTIE[name]) || (window.LEVEL_LOTTIE && window.LEVEL_LOTTIE[name]) || null;
  }
  function frameOf(anim, pct) {
    var tf = anim.totalFrames || 100;
    return Math.max(0, Math.min(tf - 1, (pct / 100) * (tf - 1)));
  }
  function set(el, pct, animate) {
    var anim = el.__rvLottie; if (!anim) { el.setAttribute("data-frame", pct); return; }
    var to = frameOf(anim, pct);
    if (el.__rvRAF) { cancelAnimationFrame(el.__rvRAF); el.__rvRAF = null; }
    if (!animate) { anim.goToAndStop(to, true); el.__rvFrame = to; return; }
    var from = el.__rvFrame || 0, start = null, dur = Math.min(950, 220 + Math.abs(to - from) * 7);
    function step(ts) {
      if (start == null) start = ts;
      var t = Math.min(1, (ts - start) / dur), e = 1 - Math.pow(1 - t, 3);
      var f = from + (to - from) * e;
      anim.goToAndStop(f, true); el.__rvFrame = f;
      if (t < 1) el.__rvRAF = requestAnimationFrame(step); else { el.__rvFrame = to; el.__rvRAF = null; }
    }
    el.__rvRAF = requestAnimationFrame(step);
  }
  function render(el) {
    if (el.__rvLottie) return el.__rvLottie;
    var name = el.getAttribute("data-lottie");
    var pct = parseFloat(el.getAttribute("data-frame") || "0");
    var noAnim = el.getAttribute("data-animate") === "off";
    var data = dataFor(name);
    if (!data || !window.lottie) return null;
    var anim = window.lottie.loadAnimation({
      container: el, renderer: "svg", loop: false, autoplay: false,
      animationData: clone(data),
      rendererSettings: { preserveAspectRatio: el.getAttribute("data-fit") || "xMidYMid meet" },
    });
    el.__rvLottie = anim; el.__rvFrame = 0;
    anim.addEventListener("DOMLoaded", function () {
      if (noAnim) set(el, pct, false);
      else { el.__rvFrame = 0; set(el, pct, true); }
    });
    return anim;
  }
  function scan(container) {
    (container || document).querySelectorAll(".rv-lottie, .lvl-lottie").forEach(render);
  }
  function init() {
    if (!window.lottie || (!window.RV_LOTTIE && !window.LEVEL_LOTTIE)) { setTimeout(init, 40); return; }
    scan(document);
  }
  window.RVLottie = { render: render, set: set, scan: scan, init: init, frameOf: frameOf };
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
